import React from "react";
import { useTranslation } from "next-i18next";
import PostsCardMini from "../PostsCardMini/PostsCardMini";
import dayjs from "dayjs";

export default function DiscoverBlogArticles({
    posts,
    title
}) {
    const { t } = useTranslation();
    return (
        <div className="discover_blog_articles_container">
            <div className="discover_blog_articles_title">
                <p>{title}</p>
            </div>
            <div className="discover_blog_articles_carroussel_gradient_wrapper">

            <div className="discover_blog_articles_carroussel_wrapper">
                <div className="discover_blog_articles_carroussel_card">
                    {posts.data.map((p, i) => {
                        const tag = p.attributes.tags.data.map((t) => t.attributes.name);
                        return (
                            <PostsCardMini
                                key={i}
                                imageUrl={p.attributes?.preview_image?.data[0]?.attributes?.url}
                                title={p.attributes.title}
                                author={p.attributes.author}
                                date={dayjs(p.attributes.publishedAt).format("DD MMMM YYYY")}
                                tags={tag}
                                description={p.attributes.description}
                                slugUrl={p.attributes.slug}
                            />
                        );
                    })}
                </div>
            </div>
            </div>
        </div>
    );
}
